export default __webpack_public_path__ + "static/media/item.173870fc.webp";